// components/PromocodeWidget/CheckItem/CheckItem.jsx
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Link from '../../AppLink';

import CheckIcon from '../../../icons/done.svg';

// Router
import { getRoute, paths } from '../../../entry/routes';

import styles from './CheckItem.styl';

const cx = classNames.bind(styles);

export default function CheckItem(props) {
  const { criteria, check, goods, code, idx, isOutOfStock, onOpenModal } = props;

  const hasGoods = goods.length > 0;
  const isClickable = hasGoods && !isOutOfStock;

  const Component = isClickable ? Link : 'div';
  const to = hasGoods ? getRoute(paths.stockConditions, idx, code) : getRoute(paths.home);

  const handleClick = e => {
    if (!onOpenModal) {
      return;
    }

    if (!isClickable) {
      return;
    }

    e.preventDefault();
    onOpenModal({ isReplace: false });
  };

  return (
    <Component
      to={to}
      className={cx('CheckItem', {
        CheckItem_checked: check && !isOutOfStock,
        CheckItem_outOfStock: isOutOfStock,
      })}
      onClick={handleClick}
    >
      <div className={cx('CheckItem__criteria')}>
        <CheckIcon className={cx('CheckItem__icon', { CheckItem_outOfStock: isOutOfStock })} />
        {criteria}
      </div>
    </Component>
  );
}

CheckItem.defaultProps = {
  goods: [],
  isOutOfStock: false,
  onOpenModal: undefined,
};

CheckItem.propTypes = {
  criteria: PropTypes.string.isRequired,
  check: PropTypes.bool.isRequired,
  goods: PropTypes.array,
  code: PropTypes.string.isRequired,
  idx: PropTypes.number.isRequired,
  isOutOfStock: PropTypes.bool,
  onOpenModal: PropTypes.func,
};
